module.exports = __webpack_public_path__ + "img/服務條款7.7e2bc49f.png";